/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './heading.scss';

class Heading extends Component {
  static propTypes = {
    component: PropTypes.oneOf(['span', 'a']),
    size: PropTypes.oneOf([
      'extrasmall',
      'small',
      'medium',
      'large',
      'extralarge',
    ]),
    href: PropTypes.string,
  };

  static defaultProps = {
    component: 'span',
    href: null,
    size: 'large',
  };

  render() {
    const { className, children, size, component, href, onClick, ...props } =
      this.props;
    const Element = href ? 'a' : component;
    const classes = classnames(className, styles.heading, styles[size], {
      [styles.clickable]: !!onClick,
    });

    const elementProps = {};
    if (href) {
      elementProps.href = href;
    }
    if (onClick) {
      elementProps.onClick = onClick;
    }

    return (
      <Element
        {...props}
        {...elementProps}
        className={classes}
        role={href ? 'link' : 'heading'}
      >
        {children}
      </Element>
    );
  }
}

export default Heading;
